import React from 'react';

import Copy from '../../../common/components/Copy';
import DelayedPaper from './DelayedPaper';

const SiteLoading = () => (
  <DelayedPaper>
    <Copy.Body>Loading...</Copy.Body>
  </DelayedPaper>
);

export default SiteLoading;
